import React from 'react';
import { useTranslation } from 'react-i18next';
import ChatBubble from '../ChatBubble';

function getDateLabel(ts, t) {
  if (!ts) return null;
  const d = ts?.toDate ? ts.toDate() : ts?.seconds ? new Date(ts.seconds * 1000) : new Date();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === today.toDateString()) return t('chat.today');
  if (d.toDateString() === yesterday.toDateString()) return t('chat.yesterday');
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

export function groupMessagesByDate(messages, t) {
  const groups = [];
  let currentDate = null;
  messages.forEach((msg) => {
    const dateLabel = getDateLabel(msg.timestamp, t);
    if (dateLabel !== currentDate) {
      currentDate = dateLabel;
      groups.push({ type: 'date', label: dateLabel });
    }
    groups.push({ type: 'message', ...msg });
  });
  return groups;
}

export default function ChatMessagesList({ messages, currentUserId, loading }) {
  const { t } = useTranslation();
  const grouped = groupMessagesByDate(messages, t);

  return (
    <>
      {grouped.map((item, i) =>
        item.type === 'date' ? (
          <div key={`date-${i}`} className="chatDateDivider">{item.label}</div>
        ) : (
          <ChatBubble key={item.id} message={item} isOwn={item.senderId === currentUserId} />
        )
      )}
      {messages.length === 0 && !loading && (
        <div className="chatEmptyState">{t('ui.noMessagesYet')}</div>
      )}
    </>
  );
}
